// extracted by mini-css-extract-plugin
export default {"clientDetailsContainer":"ClientDetails_clientDetailsContainer__UJdgK","clientNameLink":"ClientDetails_clientNameLink__6zZbS","contactDetails":"ClientDetails_contactDetails__lpiSN"};